<template>
  <!-- TRIP COSTS -->
  <div class="tcp-container">
    <div :id="`itemexpander`" class="tcp-main" :class="{ 'item-active': dropdown }" @click="toggleExpand">
      <div class="item-title">
        <i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle">
          <span>credit_card</span>
        </i>
        <span>TRIP COST &amp; PAYMENT</span>
      </div>
      <div class="toggle-container d-flex">
        <span v-if="!dropdown">+</span>
        <span v-else>-</span>
      </div>
    </div>

    <div v-if="!friendFamily && dropdown" class="tcp-body">
      <!--** Many styles below come from balance history scss sheet **-->
      <div v-if="accountInfo" class="price">
        <div class="price-amount-container">
          <div class="price-amount-due-date">
            <p class="due-date-large-text align-self-center">This quote is valid until {{ accountInfo.duebyDate }}</p>
            <p class="due-date-small-text align-self-center">This price is inclusive and you will not get any nasty hidden
              charges, such as unadvised resort fees</p>
          </div>
         
          <b-row v-if="accountInfo.totalDesc" class="d-flex justify-content-center m-0 price-amount-prov">
            <b-col md="2" lg="2" class="p-0 justify-content-center text-align-center"></b-col>
            <b-col md="8" lg="7" class="p-0 payment-table-data inclusive-text">Inclusive price</b-col>
            <b-col md="2" lg="2" class="p-0 payment-table-amounts">{{ numberFormat(accountInfo.totalCost) }}</b-col>
          </b-row>
          <b-row class="d-flex justify-content-center m-0 ">
            <b-col md="2" lg="2" class="p-0 justify-content-center text-align-center"></b-col>
            <b-col md="8" lg="7" class="p-0 payment-table-data">Total amount due</b-col>
            <b-col md="2" lg="2" class="p-0 payment-table-amounts">{{ numberFormat(accountInfo.balanceCost)
            }}</b-col>
          </b-row>
      
        </div>
        <div class="price-amount-prov-btn text-center" @click="openMakeAPaymentModal">
          <h4 class="m-0">Click here to confirm your booking</h4>
        </div>
        <div class="price-amount-info">
          <p>For more information about your booking, visit</p>
          <router-link :to="{ name: 'landing' }" class="tcp-link pl-1">
            ViewTrail Home
          </router-link>
        </div>
      </div>
    </div>
    <MakeAPayment ref="MakeAPayment" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MakeAPayment from "@/modules/navigation/modals/payment-hub/make-payment";

export default {
  components: {
    MakeAPayment
  },
  data() {
    return {
      dropdown: true,
      historyDropdown: false,
    };
  },
  computed: {
    ...mapGetters({
      accountInfo: "booking/getAccount",
      friendFamily: "friendFamily/isFriendFamily",
    }),
  },
  methods: {
    toggleExpand() {
      this.dropdown = !this.dropdown;
    },
    expandAll() {
      this.dropdown = true;
      this.checkinDropdown = true;
    },
    collapseAll() {
      this.dropdown = false;
      this.checkinDropdown = false;
    },
    historyDropDown() {
      this.historyDropdown = !this.historyDropdown;
    },
    openMakeAPaymentModal() {
      this.$refs.MakeAPayment.showModal();
    },
    numberFormat(string) {
      // eliminate white space
      let regexString = string.replace(/\£\s*/g, "£");
      // add "," for thousands
      regexString = regexString.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      // remove .00
      if (regexString.includes('.00')) {
        const removeZeroDecimal = regexString.split('.00')
        return removeZeroDecimal[0]
      }
      return regexString;
    },
  },
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
